import { ScreenProps } from '@components-common/types';
import { ConfigElement } from '@components-fabric/types';
import { mapToolbar } from './toolbar';
import { mapTable } from './table';
import { mapView } from './view';

export const mapIndexScreen = (config: ConfigElement, context: ScreenProps) => {
  context.type = 'index';
  const result = {
    type: 'index',
    view: {
      ...mapView(config, context),
      ...{
        props: {
          toolbar: mapToolbar(config, context),
          table: mapTable(config, context, 'editor'),
        },
      },
    },
  };
  return result;
};
